module.exports = __webpack_public_path__ + "static/media/dvd01.70bab176.jpg";